export function nextPartyDate() {
  const now = new Date();
  const year = now.getFullYear();
  let target = new Date(year, 10, 20, 20, 0, 0);
  if (now > target) target = new Date(year + 1, 10, 20, 20, 0, 0);
  return target;
}

export function pad(n) {
  return String(n).padStart(2, "0");
}

function stamp(date) {
  const p = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}${p(date.getMonth() + 1)}${p(date.getDate())}` +
    `T${p(date.getHours())}${p(date.getMinutes())}00`
  );
}

export function calendarUrl() {
  const start = nextPartyDate();
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  end.setHours(3, 0, 0, 0);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: "18° di Ginevra Mosi",
    dates: `${stamp(start)}/${stamp(end)}`,
    details: "Una notte speciale per brindare insieme e accendere un nuovo inizio.",
    location: "Casa Aurora, Cascina",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("Casa Aurora, Cascina, PI");
